var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 4.66671H9.91658V3.50004C9.91658 1.89004 8.60992 0.583374 6.99992 0.583374C5.38992 0.583374 4.08325 1.89004 4.08325 3.50004V4.66671H3.49992C2.85825 4.66671 2.33325 5.19171 2.33325 5.83337V11.6667C2.33325 12.3084 2.85825 12.8334 3.49992 12.8334H10.4999C11.1416 12.8334 11.6666 12.3084 11.6666 11.6667V5.83337C11.6666 5.19171 11.1416 4.66671 10.4999 4.66671ZM6.99992 9.91671C6.35825 9.91671 5.83325 9.39171 5.83325 8.75004C5.83325 8.10837 6.35825 7.58337 6.99992 7.58337C7.64159 7.58337 8.16658 8.10837 8.16658 8.75004C8.16658 9.39171 7.64159 9.91671 6.99992 9.91671ZM5.24992 4.66671V3.50004C5.24992 2.53171 6.03159 1.75004 6.99992 1.75004C7.96825 1.75004 8.74992 2.53171 8.74992 3.50004V4.66671H5.24992Z",
    fill: "#0F62FE",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ab4d478b69c75db0c0103fc03c0d8bd7.svg";
export { ForwardRef as ReactComponent };